import {Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ItemService} from "../../services/api/item/item.service";
import {ItemCreateRequest, ItemResponse, ItemUpdateRequest} from "../../services/api/item/model";
import {format_price} from "../../utils/helper";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow, MatRowDef, MatTable
} from "@angular/material/table";
import {FormsModule} from "@angular/forms";
import {HeadComponent} from "../../components/head/head.component";
import {PopinComponent} from "../../components/popin/popin.component";
import {NgIf} from "@angular/common";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-items-page',
  standalone: true,
  imports: [
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
    MatHeaderCellDef,
    FormsModule,
    HeadComponent,
    PopinComponent,
    NgIf,
    MatButton,
    MatIcon,
    MatIconButton
  ],
  templateUrl: './items-page.component.html',
  styleUrl: './items-page.component.css'
})
export class ItemsPageComponent implements OnInit, OnChanges {

  itemForm = {
    name: "",
    description: "",
    category: "",
    maximum_quantity: "",
    minimum_quantity: "",
    sales_price: "",
    purchase_price: "",
    piece_price: "",
    pack_price: ""
  }
  itemsData: ItemResponse[] = [];
  filterData: ItemResponse[] = [];
  displayedColumns: string[] = [
    'category',
    'name',
    'minimum_quantity',
    'purchase_price',
    'sales_price',
    'pack_price',
    'piece_price',
    'item_id_modify',
    'item_id_delete',
    'item_id_duplicate'
  ];
  isPopinOpen: boolean = false;
  isdeletePopin: boolean = false;
  errorMessage = '';
  itemToDelete: number | undefined

  constructor(
    private itemService: ItemService,
  ) {
  }

  ngOnInit() {
    this.getItems();
  }

  ngOnChanges() {
    this.getItems();
  }

  getItems() {
    this.itemService.getItems().subscribe(res => {
      this.itemsData = res.map(item => ({
        ...item,
        isEditMode: false
      }));
      this.filterData = this.itemsData.sort((a, b) => a.category.localeCompare(b.category));
    })
  }

  toggleEditMode(element: ItemResponse) {
    element.isEditMode = !element.isEditMode;
  }

  createItems() {
    if (!this.checkFilledForm()) {
      this.errorMessage = "Tous les champs doivent être remplis";
    } else if (+this.itemForm.sales_price < +this.itemForm.purchase_price) {
      this.errorMessage = "Prix de vente < Prix d'achat";
    } else {
      const body: ItemCreateRequest = {
        name: this.itemForm.name,
        description: this.itemForm.description,
        category: this.itemForm.category,
        sales_price: +this.itemForm.sales_price,
        purchase_price: +this.itemForm.purchase_price,
        minimum_quantity: +this.itemForm.minimum_quantity,
        maximum_quantity: +this.itemForm.maximum_quantity,
        piece_price: +this.itemForm.piece_price,
        pack_price: +this.itemForm.pack_price,
      };
      this.itemService.createItem(body).subscribe(
        res => {
          this.getItems();
          this.resetForm();
          this.closePopin();
        },
        error => {
          if (error.status === 409) {
            this.errorMessage = "Nom d'article déjà existant";
          }
        }
      )
    }
  }

  deleteItem(item_id: number) {
    this.isdeletePopin = true;
    this.itemToDelete = item_id
  }

  duplicateItem(item_id: number) {
    this.isPopinOpen = true;
    this.prefillForm(item_id);
  }

  confirmDelete() {
    if (this.itemToDelete) {
      this.itemService.deleteItem(this.itemToDelete).subscribe(res => {
        this.getItems();
        this.isdeletePopin = false;
        this.itemToDelete = undefined;
      });
    }
  }


  updateItem(element: ItemResponse) {
    if (+element.sales_price < +element.purchase_price) {
      this.errorMessage = "Prix de vente < Prix d'achat";
    } else {
      const body: ItemUpdateRequest = {
        name: element.name,
        sales_price: +element.sales_price,
        minimum_quantity: +element.minimum_quantity,
        purchase_price: +element.purchase_price,
        pack_price: +element.pack_price,
        piece_price: +element.piece_price,
        category: element.category,
      }
      this.itemService.updateItem(element.id, body).subscribe(
        res => {
          element.isEditMode = !element.isEditMode;
        },
        err => {
          if (err.status === 409) {
            this.errorMessage = "Nom d'article déjà existant";
          } else {
            this.errorMessage = err.message;
          }
        }
      );
      this.errorMessage = "";
    }
  };

  openPopin() {
    this.isPopinOpen = true;
  }

  closePopin() {
    this.isPopinOpen = false;
    this.errorMessage = "";
    this.resetForm();
  }

  prefillForm(item_id: number) {
    let item = this.itemsData.find(item => item.id === item_id);
    if (item) {
      this.itemForm = {
        name: item.name,
        description: item.description,
        category: item.category,
        maximum_quantity: "" + item.maximum_quantity,
        minimum_quantity: "" + item.maximum_quantity,
        sales_price: "" + item.sales_price,
        purchase_price: "" + item.purchase_price,
        piece_price: "" + item.piece_price,
        pack_price: "" + item.pack_price,
      };
    }

  }

  resetForm() {
    this.itemForm = {
      name: "",
      description: "",
      category: "",
      maximum_quantity: "",
      minimum_quantity: "",
      sales_price: "",
      purchase_price: "",
      piece_price: "",
      pack_price: ""
    };
  }

  checkFilledForm(): boolean {
    return !(!this.itemForm.name ||
      !this.itemForm.maximum_quantity ||
      !this.itemForm.minimum_quantity ||
      !this.itemForm.sales_price ||
      !this.itemForm.purchase_price);

  }


  searchResults(text: string) {
    this.filterData = text.trim() === ""
      ? this.itemsData
      : this.itemsData.filter(item => item?.name.toLowerCase().includes(text.toLowerCase()));
  }

  protected readonly format_price = format_price;
}
